@let data = model();
@let columnData = column();

@switch (columnData.key) {
  @case (getColumnKey('totalPrice')) {
    @if (isNil(data.refundSummary)) {
      <app-currency [amount]="data.totalPrice" />
    } @else {
      <app-refunded-price
        [currentPrice]="data.refundSummary.currentPrice"
        [refundedPrice]="data.refundSummary.refundedPrice"
        [originalPrice]="data.refundSummary.originalPrice" />
    }
  }
  @case (getColumnKey('number')) {
    <div
      pTooltip="Kliknij, aby wyświetlić szczegóły"
      role="button"
      (click)="handleShowDetailsClick()">
      <div class="text-[#3858E9] underline decoration-dotted">
        {{ data.number }}
      </div>
    </div>
  }
  @case (getColumnKey('status')) {
    <app-order-status [status]="data.status" />
  }
  @case (getColumnKey('type')) {
    <app-admin-subscription-order-type [type]="data.type" />
  }
  @default {
    <app-table-body-no-reference-cell [columnKey]="columnData.key" />
  }
}
